export default __webpack_public_path__ + "static/media/facebookFooter.5b8d9e15.svg";